import getBasePath from '../functions/api-resource';
import resourceBuilder from '../functions/metadados-resource-builder';

export const emailAcoesContrato = (parametros, resource) => resourceBuilder.buildGET(//eslint-disable-line
  resource,
  getBasePath('job'),
  'email-acoes-contrato',
  parametros,
).doGet();
